export default __webpack_public_path__ + "static/media/contact-instagram.cdff7320.svg";